import {
    setCookie,
    getCookie,
    initializeMap,
    initMenuTrigger,
    initOpenInNewTab,
    aosConfig,
    addScollClass,
    addParalax,
    addFancyboxFixForGallery,
    addCloseCookies,
    initForm,
    googleMapInit,
    initLoadNews
} from './functions';

import Cocoen from './cocoen';

import Parallax from 'parallax-js';

import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);

const mainApp = () => {

    document.querySelectorAll('.cocoen').forEach(function (element) {
        if (element.querySelector(':scope img')) {
            new Cocoen(element);

        }
    });

    // init menu trigger
    initMenuTrigger();

    // init open in new tab
    initOpenInNewTab();

    // init AOS animation config
    //aosConfig();

    // add scroll class to body  
    addScollClass('0px');

    // add paralax to element
    //addParalax('.paralax');



    //fix gallery id for slideshow
    addFancyboxFixForGallery('.blocks-gallery-grid');

    // add close function to cookies
    addCloseCookies();



    //start - contact form
    initForm();

    googleMapInit();


    initLoadNews();


    var scene = document.querySelector('.indexHeader__topParalax');

    if (scene) {
        var parallaxInstance = new Parallax(scene, {
            relativeInput: true,
            hoverOnly: true,
            scalarX: 5,
            scalarY: 5,
        });
    }



    [...document.querySelectorAll('.indexC2__content, .indexC3__content, .indexC3__offerList, .indexC4__content, .indexC4__slider, .indexC1__container')].forEach((element) => {
        gsap.fromTo(element,
            { opacity: 0, y: 50 },
            {
                opacity: 1,
                y: 0,
                duration: 1.4,
                ease: "back.out(1.7)",
                scrollTrigger: {
                    trigger: element,
                    start: 'top 75%',
                    toggleActions: 'play play play play',
                }
            });
    });






}

document.addEventListener("DOMContentLoaded", mainApp, false);

function headerAnimation() {
    gsap.fromTo('.subpageHeader__breadcrumbs, .subpageHeader__title, .indexHeader__title, .indexHeader__text,.indexHeader__more',
        { opacity: 0, x: 50 },
        {
            opacity: 1,
            x: 0,
            duration: 1,
            ease: "back.out(1.7)",
            stagger: 0.1,
            delay: 0.6
        });

}
(function ($) {
    const mainAppWithJquery = () => {


        if ($('.intro').length > 0 && !getCookie('introShow2')) {
            const intro = gsap.timeline();
            intro.to('.intro path', { strokeDashoffset: 690, duration: 2, ease: "power1.inOut" });

            intro.to('.logoSvgText', { opacity: 1, scale: 1, y: 0, duration: 0.7, delay: 0.5 });
            intro.to('.intro', {
                duration: 1, opacity: 0, delay: 1.5, onComplete: function () {
                    // setCookie('introShow2', 1);
                    $('.intro').css({ visibility: 'hidden' });
                    $('.intro svg').css({ visibility: 'hidden' });
                    $('.intro .logoSvgText').css({ visibility: 'hidden' });
                }
            });



        } else {
            gsap.to('.intro', {
                duration: 1, opacity: 0, onComplete: function () {
                    //setCookie('introShow', 1);
                    $('.intro').css('visibility', 'hidden');

                }
            });


        }
        headerAnimation();

        $('a[href*="' + location.host + '"]:not([href$=".jpg"]):not([href$=".png"]):not([href$=".gif"]):not([href$=".pdf"]):not([href$=".txt"]):not([href$=".doc"]):not([href$=".docx"]):not([href$=".odt"]):not([href$=".odf"]):not([target="_blank"])')
            .click(function (e) {
                if (!e.ctrlKey) {
                    $('.intro').css('visibility', 'visible');
                    gsap.to('.intro', {
                        duration: 0.5, opacity: 1
                    });
                }
            });


        $('.withRectangle .wp-block-column:first-child h2').after('<div class="rectangle"></div>');

        [...document.querySelectorAll('.rectangle')].forEach((element) => {
            gsap.fromTo(element,
                { opacity: 0, y: 50 },
                {
                    opacity: 1,
                    y: 0,
                    duration: 1.4,
                    ease: "back.out(1.7)",
                    scrollTrigger: {
                        trigger: element,
                        start: 'top 80%',
                        toggleActions: 'play play play play',
                    }
                });
        });



        $('.mainHeader .menu-item a').each(function () {
            $(this).html($(this).html().replace(' ', '<br />'));
        });

        if ($('.indexC4__slider').length > 0) {
            $('.indexC4__slider').slick({
                infinite: false,
                arrows: true,
                dots: false,
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                autoplaySpeed: 10000,
            });
        }


        $('.schema-faq-question').click(function () {
            var p = $(this).parent();
            $('.schema-faq-section.active .schema-faq-answer').slideUp(500);
            if (!p.hasClass('active')) {
                $('.schema-faq-section').removeClass('active');
                p.addClass('active');
                p.find('.schema-faq-answer').slideDown(500);
            } else {

                $('.schema-faq-section').removeClass('active');
            }
        });

        let gMenu = $('.menuAnchorTarget');
        if (gMenu.length > 0) {
            let newMenu = $('<ul></ul>');
            const scrollActive = (item) => {

                $('.gmaItem').parent().removeClass('active');
                $('.gmaItem[data-href=' + $(item).data('slug') + ']').parent().addClass('active');
            };
            gMenu.each(function (index, item) {

                newMenu.append('<li class="page_item"><a class="gmaItem" data-href="' + $(item).data('slug') + '">' + $(item).data('title') + '</a></li>');

                ScrollTrigger.create({
                    trigger: item,
                    start: "top 50%",
                    end: "bottom 10%",
                    onEnter: () => scrollActive(item),
                    onEnterBack: () => scrollActive(item),
                });


            });

            let activeItem = $('.submenu .page_item.current_page_item');
            if (activeItem.length > 0) {
                activeItem.append(newMenu);
            } else {
                let menuAllWrap = $('<aside class="mainContent__aside"></aside>');
                newMenu.addClass('submenu');
                newMenu.prepend($('#tmpl-submenuHeader').html());
                menuAllWrap.append(newMenu);
                $('.mainContent__container').prepend(menuAllWrap);
            }


            $('.gmaItem').click(function () {
                $('.gmaItem').parent().removeClass('active');
                $(this).parent().addClass('active');
                const targetName = $(this).data('href');

                const targetOffset = $('.menuAnchorTarget.mat_' + targetName);

                gsap.to(window, { duration: 1, scrollTo: { y: targetOffset.offset().top - 100, x: 0 }, ease: "power3.out" });
            });
        }

        if ($('.mainContent__aside').height() >= $('.mainContent__article').height()) {
            $('.mainContent__aside').addClass('noStick');
        }
        if ($('.submenu').height() < window.innerHeight - 100 &&
            $('.submenu').height() < $('.mainContent__container').height() &&
            window.innerWidth > 768
        ) {
            const anim2Pin = ScrollTrigger.create({
                trigger: ".mainContent__aside",
                start: "top 160px",
                endTrigger: ".mainContent__container",
                end: "bottom bottom-=" + (window.innerHeight - $('.submenu').height() - 160),
                pin: true,
                pinSpacing: false,
                //markers: true
            });
            /* $(window).resize(() => {
                 console.log('refresh');
                 ScrollTrigger.refresh();
             });*/
        }



        //fancybox
        $(".blocks-gallery-item a, .fancybox, .wp-block-image a").fancybox({
            'loop': true,
            'margin': [44, 0],
            'gutter': 50,
            'keyboard': true,
            'arrows': true,
            'infobar': false,
            'toolbar': true,
            'buttons': ["slideShow", "fullScreen", "close"],
            'idleTime': 4,
            'protect': false,
            'modal': false,
            'animationEffect': "fade",
            'animationDuration': 600,
            'transitionEffect': "fade",
            'transitionDuration': 800,
        });



    };
    document.addEventListener("DOMContentLoaded", mainAppWithJquery, false);

})(jQuery);



